import ApiClient from "@/api/ApiClient.ts";

const state = {
  priceFromTo: null,
};

const mutations = {
  setPriceFromTo(state, price) {
    state.priceFromTo = price;
  },
};

const actions = {
  async getPriceFromTo({ commit }, customParams) {
    const params = {
      ...customParams,
    };
    try {
      const api = ApiClient();
      let response = await api.get("price", { params });
      commit("setPriceFromTo", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getPriceFromTo: ", error.message);
    }
  },
};

const getters = {
  priceFromTo(state) {
    if (state.priceFromTo) {
      let price = state.priceFromTo.price / 100 + " €";
      let distance =
        state.priceFromTo.distance < 1000
          ? `${state.priceFromTo.distance.toFixed(0)} metros`
          : `${(state.priceFromTo.distance / 1000).toFixed(1)} km`;
      let time =
        state.priceFromTo.time < 3600
          ? `${(state.priceFromTo.time / 60).toFixed(0)} minutos`
          : `${(state.priceFromTo.time / 3600).toFixed(1)} horas`;
      return {
        price,
        distance,
        time,
      };
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
